import Cookies from "js-cookie";
import { APP_NAME } from '@/constants';

export default {
    $_windowReload() {
        //Currently unused.
        window.location.reload();
    },
    $_toDateString(value) {
        //Currently unused.
        if (typeof value !== 'string') {
            return console.warn('Incorrect data passed to toDateString', value);
        }

        const date = new Date(value);
        return date.toLocaleDateString('en-AU');
    },
    $_toDateTimeString(value) {
        if (typeof value !== 'string') {
            return console.warn('Incorrect data passed to toDateTimeString', value);
        }

        const date = new Date(value);
        return date.toLocaleString('en-AU');
    },
    $_closeModal() {
        if (this.loading === true) {
            this.loading = false;
        }

        if (this.formLoading === true) {
            this.formLoading = false;
        }

        if (typeof this.form !== 'undefined') {
            this.form = {};
        }

        if (typeof this.ref === 'undefined') {
            return console.warn('No ref provided.');
        }

        this.$refs[this.ref].hide();
    },
    $_login(data, email) {
        const expires = 1; // Expiry length in days

        Cookies.set("role", data.role, { expires });
        Cookies.set("token", data.token, { expires });
        Cookies.set("email", email, { expires });
        Cookies.set("origin", APP_NAME, { expires });

        this.$emit("login");
        this.$root.$emit("login")

        this.$router.push("/dashboard/assessments");
    },
    // Model Methods
    $_requestTimeDifference(date1, date2) {
        const newDate1 = date1 instanceof Date ? date1 : new Date(date1);
        const newDate2 = date2 instanceof Date ? date2 : new Date(date2);

        let difference = Math.floor((newDate2.getTime() - newDate1.getTime()) / (60 * 1000));
        difference = Math.abs(difference);

        const minutes = String(difference % 60);
        const formatMinutes = minutes.length === 1 ? `0${minutes}` : minutes;

        const hours = String(Math.floor(difference / 60));

        return `T+ ${hours}:${formatMinutes}`;
    },
    $_adminDelete(model, id) {
        const isConfirmed = confirm(`Are you sure you want to delete this ${model}?`);

        if (isConfirmed === false) return;

        this.axios.delete(`/api/${model}s/${id}`)
            .then(res => {
                const modelCapitalized = model.replace(/\b\w/g, l => l.toUpperCase())
                //Remember that popup defaults to success.
                this.$root.$emit('popup', `${modelCapitalized} successfully deleted.`)
            })
            .catch(res => {
                this.$root.$emit('popup', {
                    type: 'error',
                    message: 'Internal server error. Please refresh and try again.'
                })
            })
    },
    $_adminToggleActive(model, id, isActivate = false) {
        const isConfirmed = confirm(`Are you sure you want to ${isActivate ? 'activate' : 'inactivate'} this ${model}?`);

        if (isConfirmed === false) return;

        this.axios.patch(`/api/${model}s/${id}`, { active: isActivate })
            .then(res => {
                const modelCapitalized = model.replace(/\b\w/g, l => l.toUpperCase())
                //Remember that popup defaults to success.
                this.$root.$emit('popup', `${modelCapitalized} successfully ${isActivate ? 'activated' : 'inactivated'}.`)
            })
            .catch(res => {
                this.$root.$emit('popup', {
                    type: 'error',
                    message: 'Internal server error. Please refresh and try again.'
                })
            })
    },
    $_readableNotification(notification) {
        const readable = {
            awaitingMaintenance: 'Awaiting Maintenance',
            inMaintenance: 'In Maintenance',
            misplaced: 'Misplaced',
            unnecessaryMaintenance: 'Unnecessary Maintenance',
        };

        if (!notification || !notification.name) {
            console.warn('No notification passed to readableNotification.');
            return;
        }

        if (notification.isCustom === true) {
            //Custom notifications have readable names already
            return notification.name;
        }

        const key = notification.name;
        if (key in readable === false) {
            console.warn('Invalid value passed to readableNotification.');
            return '';
        }

        return readable[key];
    },
    $_msToHHMM(value) {
        if (typeof value !== 'number') {
            return console.warn('Incorrect data passed to $_msToHHMM', value);
        }

        const minutes = value / (60 * 1000);

        return `${Math.floor(minutes / 60)}h ${Math.ceil(minutes % 60)}m`;
    },
}